export const colors = {
  bgColor: "#F6F6F6",
  cardBgColor: "#ffffff",
  fontPrimary: "#242424",
  lightGrey: "#E3E3E3",
  white: '#fff',
  blue: '#1382C2',
  green: '#1e966e',
}